import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-wg-footer',
  styleUrl: './wg-footer.css',
  templateUrl: './wg-footer.html',
})
export class WgFooter {}
